import layoutTypes from '@types/basic/layout'
import userTypes from '@types/basic/user'

const initialState = {
  users: {},
  isLogin: false
}

const user = (state = initialState, { type, payload }) => {
  switch (type) {
    case layoutTypes.SET_USER: {
      return {
        ...state,
        isLogin: true,
        users: payload || {}
      }
    }
    case userTypes.RESET_USER_INFO: {
      return {
        ...state,
        users: {
          ...state.users,
          ...payload
        }
      }
    }
    case userTypes.RESET_USER: {
      return {
        isLogin: false,
        users: {}
      }
    }
    case userTypes.SET_BRAND_LIST: {
      const { users } = state
      return {
        ...state,
        users: {
          ...users,
          brandList: payload || []
        }
      }
    }
    case userTypes.SET_STORE_CHANNEL: {
      const { users } = state
      return {
        ...state,
        users: {
          ...users,
          storeChannels: payload || []
        }
      }
    }
    case userTypes.SET_REGISTER_CHANNEL: {
      const { users } = state
      return {
        ...state,
        users: {
          ...users,
          registerChannels: payload || []
        }
      }
    }
    case userTypes.UPDATE_AUTH_CODES: {
      const { users } = state
      return {
        ...state,
        users: {
          ...users,
          authCodes: payload || []
        }
      }
    }
    default: {
      return state
    }
  }
}

export default user
